import './_order.refunds.history.scss';
import React, { useEffect, useRef, useState } from 'react';
import { Nav, NavItem, Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import Pagination from './components/pagination';

import Search from './components/search';
import { getUsersRefunds } from '../../../../services/endpoints/users';
import { getErrorMessage } from '../../../../utils/helper';
import EmptyTable from '../../../../components/Table/TableEmpty';
import { tabs } from './helpers';
import TableEmptySearch from '../../../../components/Table/EmptySearch';
import AlertComponent from '../../../../components/Alert';
import Spinner from '../../../../components/Loaders/Spinner';

const OrderRefundsHistory = ({ user }) => {
  const history = useHistory();
  const [data, setData] = useState({
    isLoading: true,
    init: false,
    refunds: [],
    filters: {
      query: null,
      type: null,
      user: user.id,
    },
    pagination: {
      count_items: 100,
      current_page: 1,
      page_size: 100,
      pages: 1,
      total_count: 100,
    },
    error: null,
  })

  const bodyRef = useRef(null);

  const { refunds, filters, pagination, isLoading, error, init } = data;

  const scrollToTop = () => {
    const myDiv = document.getElementsByClassName('orders-refunds__modal');
    if (myDiv?.[0]) {
      myDiv[0].scrollTop = 0;
    }
  }

  const onChangeFilter = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      isLoading: true,
      filters: {
        ...prevState.filters,
        [key]: value,
      },
      pagination: {
        ...prevState.pagination,
        current_page: 1,
      },
    }))
  }

  const onClickOrderId = (e, id) => {
    e.preventDefault();
    history.push({
      pathname: '/orders',
      search: `?query=${id}&search_type=1`,
    })
  }

  const onChangePagination = (current_page) => {
    setData((prevState) => ({
      ...prevState,
      isLoading: true,
      pagination: {
        ...prevState.pagination,
        current_page,
      },
    }))
  }

  const getOrders = async () => {
    try {
      scrollToTop();
      const response = await getUsersRefunds({ ...filters, page: pagination.current_page })
      setData((prevState) => ({
        ...prevState,
        error: null,
        filters: response.data.filters,
        refunds: response.data.refunds,
        pagination: response.data.pagination,
      }))
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setData((prevState) => ({
        ...prevState,
        error: errorMessage,
      }))
    } finally {
      setData((prevState) => ({
        ...prevState,
        init: true,
        isLoading: false,
      }))
    }
  }

  useEffect(() => {
    if (isLoading) {
      getOrders()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  if (!init) {
    return <Spinner />
  }

  return (
    <>
      {error ? <AlertComponent text={error} /> : null}
      <div className="orders-refunds__header p-b">
        <Nav
          bsStyle="pills"
          className="tabs"
          activeKey={filters.type || 'all'}
          onSelect={(key) => onChangeFilter('type', key === 'all' ? null : key)}
        >
          {tabs.map((tab) => {
            const { label, value } = tab;
            const activeValue = value || 'all';
            return (
              <NavItem key={activeValue} eventKey={activeValue} active={activeValue === Number(filters.type)} disabled={isLoading}>
                <span>{label}</span>
              </NavItem>
            );
          })}
        </Nav>
        <Search
          disabled={isLoading}
          query={filters.query}
          onChange={(value) => onChangeFilter('query', value)}
        />
      </div>
      <div className="table-responsive">
        <Table className="orders-refunds__table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Order status</th>
              <th>Refunded amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody
            className={classNames('', { 'tbody-loading': isLoading })}
            style={{ backgroundPosition: '50%', height: '38px' }}
            ref={bodyRef}
          >
            {refunds?.length ? refunds.map((refund) => (
              <tr key={refund.order_id}>
                <td>
                  <a href={`/admin/orders?query=${refund.order_id}&search_type=1`} onClick={(e) => onClickOrderId(e, refund.order_id)}>{refund.order_id}</a>
                </td>
                <td>{refund.type_title}</td>
                <td>
                  +
                  {refund.amount}
                </td>
                <td>{refund.created}</td>
              </tr>
            )) : filters.query ? <TableEmptySearch search={filters.query} /> : <EmptyTable /> }
          </tbody>
        </Table>
      </div>
      <Pagination
        isLoading={isLoading}
        onChangePage={onChangePagination}
        pagination={pagination}
      />
    </>
  );
};

OrderRefundsHistory.propTypes = {
  user: PropTypes.object,
};

export default OrderRefundsHistory;
